import { FormGroup, Switch, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { INotficationSetting, INotificationSettings, INotificationType } from "notification/model"
import { setNotificationSetting } from "notification/tools/common"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface INotificationSettingProps {
  category: keyof INotificationSettings
  type: INotificationType
  value: INotficationSetting
  disabled?: boolean
}

export const NotificationSetting = React.memo(
  ({ category, type, value, disabled }: INotificationSettingProps): JSX.Element => (
    <FlexBox
      jc="space-between"
      gap
      fullWidth
      sx={{
        "pl": "1rem",
        "pt": ".1rem",
        "pb": ".1rem",
        "borderBottom": theme => theme.palette.border,
        "& .Mui-checked+.MuiSwitch-track": {
          backgroundColor: theme => theme.palette.action.disabled,
          border: theme => theme.palette.border
        }
      }}>
      <Typography id={`notification-switch-${category}-${type}-type-title`} color="textSecondary">
        {translate(`notification.type.${type}`)}
      </Typography>
      <FormGroup sx={{ minWidth: "8rem", flexDirection: "row" }}>
        <Switch
          id={`notification-switch-${category}-${type}-email`}
          disabled={disabled}
          checked={value.email}
          onChange={(_event, isChecked) => setNotificationSetting(category, type, { ...value, email: isChecked })}
        />
        <Switch
          id={`notification-switch-${category}-${type}-push`}
          disabled={disabled}
          checked={value.push}
          onChange={(_event, isChecked) => setNotificationSetting(category, type, { ...value, push: isChecked })}
        />
      </FormGroup>
    </FlexBox>
  )
)
